import React, { useEffect, useState } from "react";
import ReviewConfirmationView from "./components/ReviewSummaryView";
import Error from "../../../shared/components/Error";
import { withTranslation } from "react-i18next";
import { addToGoogleDataLayer } from "../../../shared/const/utls.js";

const ReviewSummary = ({ i18n }) => {
  const [isError, setIsError] = useState(false);

  //   useEffect(() => {
  //     document.title = "Review - HARPs - Government of Nova Scotia";
  //   }, []);

  useEffect(() => {
    if (i18n?.language === "en") {
      document.title =
        "Review your answers before submitting your application - HARP- Government of Nova Scotia";
    } else {
      document.title =
        "Vérifiez vos réponses avant de soumettre votre demande - Allocation pour services à domicile chez les aînés - Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language]);

  useEffect(() => {
    try {
      addToGoogleDataLayer("review-summary", "Pay a Debt", i18n.language);
      window.scrollTo(0, 0);
    } catch (e) {
      console.log(e);
    }
  }, [i18n.language]);

  return isError ? (
    <Error />
  ) : (
    <ReviewConfirmationView setIsError={setIsError} />
  );
};

export default withTranslation("common")(ReviewSummary);
